import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useSidebarContext } from '../../context/sidebar';
import { useUserDetialsContext } from '../../context/user-details';
import getSideBarItems from '../../static/data/SidebarItems';
import RenderMultiOption from './RenderMultiOption';

const NavLinks = () => {
  const pathname = window.location.pathname.substring(1) || 'coverage';
  // To keep the billing, settings, and polices open by default
  const { openItemsId, setOpenItemsId } = useSidebarContext();
  const {
    userDetails: { status, site_tour, show_chat, isIndividualUser, promo_script_tokens, promo_book_tokens, promo_expiration_date }
  } = useUserDetialsContext();

  const isPromoValid = () => {
    if (!promo_expiration_date) return false;
    return new Date() <= new Date(promo_expiration_date);
  };

  const hasPromoCredits = isPromoValid() && (promo_script_tokens > 0 || promo_book_tokens > 0);

  const multiOptionClickHandler = (itemId) => {
    if (openItemsId?.includes(itemId)) {
      const newOpenedItemsId = openItemsId?.filter((id) => id !== itemId);
      setOpenItemsId(newOpenedItemsId);
    } else {
      const newOpenedItemsId = [...openItemsId];
      newOpenedItemsId.push(itemId);
      setOpenItemsId(newOpenedItemsId);
    }
  };

  const renderSideBarItems = () => {
    const sideBarItems = getSideBarItems(isIndividualUser);
    return sideBarItems.map((item, index1) => {
      if (item.linkTo == 'query' && (show_chat === false || (status === 'not_subscribed' && !hasPromoCredits))) return;
      const isActive = pathname === item?.linkTo;
      if (item.isMultiOption) {
        const isOpened = openItemsId?.includes(item.id);
        return (
          <RenderMultiOption
            item={item}
            isActive={isActive}
            isOpened={isOpened}
            onClick={() => multiOptionClickHandler(item?.id)}
          />
        );
      }
      return (
        <li key={item.id}>
          <NavLink
            to={item.linkTo}
            exact="true"
            className={`flex items-center gap-2 px-2.5 py-1.5 w-full leading-6 ${
              isActive
                ? 'bg-primary font-Inter rounded-xl'
                : 'bg-transparent hover:!text-secondary hover:border-l-secondary'
            } border-2 border-transparent transition-all duration-100 cursor-pointer group ${item.className}`}>
            {item.icon(isActive)}
            <span className="w-full text-[11px] font-semibold">{item?.value}</span>
          </NavLink>
          {item.seperator && <div className={`h-[0.0625rem] my-3 bg-[#1D2939]`} />}
        </li>
      );
    });
  };

  return (
    <div className="w-full">
      <ul className="flex flex-col gap-2 text-white w-full h-full font-Inter">
        {renderSideBarItems()}
      </ul>
    </div>
  );
};

export default NavLinks;
